import { useNavigate } from 'react-router-dom';
import greenpillBg from '../../assets/greenpill/greenpillBg.png';
import { activityHistory } from '../../constants/activityHistory';
import Pagination from '../../ui/Pagination';
import Table from '../../ui/Table';
import Heading from '../../ui/Heading';
import BackButton from '../../assets/icons/BackButton';
import { getActivityHistory } from '../../apis/geenpills/apis';
import { useLoadingState } from '../../hooks/useLoader';
import { useEffect, useState } from 'react';
import Loader from '../../ui/Loader';
import { formatRelativeDate } from '../../helpers/formatRelativeDate';
import NoDataAvailable from '../../ui/NoDataAvailable';
import { achievmentsData, allAchievementImages, allActivityImages } from '../../constants/achievmentsData';
import { formatNumber } from '../../helpers/formatNumber';

const ActivityHistory = () => {
    const navigate = useNavigate();
    const { loading, startLoading, stopLoading } = useLoadingState();
    const [activityHistories, setActivityHistories] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalEntries, setTotalEntries] = useState(0);
    const [entriesPerPage, setEntriesPerPage] = useState(10);

    useEffect(
        function () {
            const fetchData = async () => {
                try {
                    startLoading();
                    const { data, entryCount } = await getActivityHistory(currentPage, entriesPerPage);

                    setActivityHistories(data);
                    setTotalEntries(entryCount);
                } catch (error) {
                    console.log(error);
                } finally {
                    stopLoading();
                }
            };
            fetchData();
        },
        [currentPage, entriesPerPage]
    );
    const entriesHandler = (val) => {
        setEntriesPerPage(val);
    };

    return (
        <div className='pt-9 px-9'>
            <div className="  w-full  ">
                <div className="flex items-center">
                    <BackButton onClick={() => navigate(-1)} />
                    <Heading type={'pageHeading'} className={'text-textPrimary ml-3'}>
                        Activity History
                    </Heading>
                </div>
                <Table cols="grid-cols-6" className=" ">
                    <Table.Header headerClassName="pt-0 pb-1" isBorder={false}>
                        <p className=" col-span-1 justify-self-start  font-semibold text-textPrimary ">Date</p>
                        <p className=" col-span-1 font-semibold text-textPrimary ">Impact Points</p>
                        <p className=" col-span-4  font-semibold text-textPrimary ">Activity</p>
                    </Table.Header>
                    {loading ? (
                        <div className="flex h-[50vh] items-center justify-center">
                            <Loader />
                        </div>
                    ) : activityHistories?.length === 0 ? (
                        <NoDataAvailable />
                    ) : (
                        activityHistories.map((k) => {
                            const activityFound = allActivityImages?.find((obj) => obj?.type === k?.activityType);

                            return (
                                <Table.Row key={k} isBorder={false}>
                                    <p className="col-span-1 text-textPrimary ">{formatRelativeDate(k?.createdAt)} </p>
                                    <p className="col-span-1 text-textPrimary ">
                                        {' '}
                                        {formatNumber(k?.impactPointsIssued)}{' '}
                                    </p>
                                    <p className="col-span-4 text-textPrimary ">{activityFound?.label}</p>
                                </Table.Row>
                            );
                        })
                    )}

                    {totalEntries > 10 && (
                        <div className="w-[100%]     mx-auto">
                            <Pagination
                                className="pt-[.65rem] pb-[.65rem]"
                                hoverColor="hover:text-textPrimary"
                                currentColor="bg-neutral50D"
                                textActive="text-textPrimary"
                                currentPage={currentPage}
                                totalPages={Math.ceil(totalEntries / 10)}
                                entriesPerPage={entriesPerPage}
                                entriesHandler={entriesHandler}
                                onPageChange={setCurrentPage}
                                border="border-borderUnderline"
                                hoverBorder="hover:border-borderUnderline"
                            />
                        </div>
                    )}
                </Table>
            </div>
        </div>
    );
};

export default ActivityHistory;
